import { createIcon } from '../OriginIcon/iconHelper';
import React from 'react';

export default createIcon(
  'PitchedRoof',
  <React.Fragment>
    <g stroke="none">
      <g transform="translate(2.000000, 3.000000)">
        <polygon points="3 9 3 17 8 17 8 11 12 11 12 17 17 17 17 9 10 4" />
        <polygon points="10.0000125 1.25e-05 3.0000125 5.0000125 1.25e-05 7.1428875 1.4583875 8.6011375 3.0000125 7.5 10.0000125 2.5000125 17.0000125 7.5 18.5415125 8.6011375 20.0000125 7.1428875 17.0000125 5.0000125" />
      </g>
    </g>
  </React.Fragment>
);
